export enum LayerType {
  MBTILES = 'mbtiles',
  IMAGE_OVERLAY = 'image_overlay',
  /** Imported features too many to edit shape by shape, drawn from one GeoJSON file. */
  VECTOR = 'vector',
}
